import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AnalyticsService } from '@app/shared/modules/analytics/services/analytics.service';
import { TranslateService } from '@ngx-translate/core';
import { EvsbThankYouOutboundComponent } from './evsb-thank-you-outbound.component';
import { EvsbThankYouOutboundService } from './evsb-thank-you-outbound.service';

@Component({
  templateUrl: './evsb-thank-you-outbound.component.html',
  styleUrls: ['./evsb-thank-you-outbound.component.scss'],
})
export class EvsbThankYouOutboundStationsComponent extends EvsbThankYouOutboundComponent {
  constructor(
    public translate: TranslateService,
    protected pageService: EvsbThankYouOutboundService,
    protected title: Title,
    protected analyticsService: AnalyticsService,
    protected router: Router
  ) {
    super(translate, pageService, title, analyticsService, router);
  }

  protected analyticsNavigate() {
    this.analyticsService.push({
      event: 'cta',
      eventCategory: 'b-to-b-ev-simulator',
      eventAction: 'click-cta-outbound-charging-station-contact-confirmation-screen',
      eventLabel: 'back-to-website',
    });
  }
}
